'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxLabelStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  disabled: _propTypes2.default.bool,
  checked: _propTypes2.default.bool,
  textFree: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};
var defaultProps = {
  disabled: false,
  checked: false,
  textFree: false
};

var labelSize = function labelSize(_ref) {
  var themeFromProvider = _ref.theme,
      textFree = _ref.textFree;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var size = theme.reactackle.components.checkbox.input.size;
  var checkboxTextSpacing = theme.reactackle.components.checkbox.label.checkboxTextSpacing;
  var paddingLeft = textFree ? (0, _reactackleCore.getValueString)(size) : 'calc(' + (0, _reactackleCore.getValueString)(size) + ' + ' + (0, _reactackleCore.getValueString)(checkboxTextSpacing) + ')';
  return (0, _styledComponents.css)(['min-width:', ';max-width:', ';min-height:', ';padding-left:', ';&:empty{padding-left:', ';}'], (0, _reactackleCore.getValueString)(size), textFree ? (0, _reactackleCore.getValueString)(size) : '100%', (0, _reactackleCore.getValueString)(size), paddingLeft, (0, _reactackleCore.getValueString)(size));
};

var labelText = function labelText(_ref2) {
  var themeFromProvider = _ref2.theme,
      disabled = _ref2.disabled;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var labelSource = theme.reactackle.components.checkbox.label;
  var fontSize = labelSource.fontSize,
      fontColor = labelSource.fontColor,
      lineHeight = labelSource.lineHeight;
  var disabledColor = labelSource.disabled.color;
  return '  \n    line-height: ' + lineHeight + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    \n    ' + (disabled ? '\n        cursor: default;\n        color: ' + disabledColor + ';\n      ' : '\n        cursor: pointer;\n        color: ' + fontColor + ';\n      ') + '\n  ';
};

var checkboxSize = function checkboxSize(_ref3) {
  var themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var size = theme.reactackle.components.checkbox.input.size;
  return '  \n    width: ' + (0, _reactackleCore.getValueString)(size) + ';\n    height: ' + (0, _reactackleCore.getValueString)(size) + ';\n  ';
};

var checkboxStyle = function checkboxStyle(_ref4) {
  var themeFromProvider = _ref4.theme,
      checked = _ref4.checked,
      disabled = _ref4.disabled;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.checkbox.input;
  var size = path.size,
      borderWidth = path.borderWidth,
      borderRadius = path.borderRadius;
  var source = checked ? path.checked : path;
  return '\n    &::before {\n      line-height: calc(' + (0, _reactackleCore.getValueString)(size) + ' - ' + borderWidth * 2 + 'px);\n      border: ' + borderWidth + 'px solid transparent;\n      border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    }\n    \n    ' + (!disabled ? '\n        &::before {\n          background-color: ' + source.backgroundColor + ';\n          border-color: ' + source.borderColor + ';\n        }\n        \n        &:hover::before {\n          background-color: ' + source.hover.backgroundColor + ';\n          border-color: ' + source.hover.borderColor + ';\n        }\n        \n        &:focus::before {\n          background-color: ' + source.focus.backgroundColor + ';\n          border-color: ' + source.focus.borderColor + ';\n        }\n      ' : '\n        &::before,\n        &:hover::before,\n        &:focus::before {\n          background-color: ' + source.disabled.backgroundColor + ';\n          border-color: ' + source.disabled.borderColor + ';\n        }\n      ') + '\n  ';
};

var CheckboxLabelStyled = exports.CheckboxLabelStyled = _styledComponents2.default.label.withConfig({
  displayName: 'CheckboxLabelStyled'
})(['position:relative;cursor:pointer;display:inline-block;width:100%;', ';', ';&:focus{box-shadow:none;outline:none;}&::before{content:\'\';display:block;text-align:center;position:absolute;top:0;left:0;', ';', ';}', ';'], labelSize, labelText, checkboxSize, (0, _reactackleCore.transition)('color, background-color, border'), checkboxStyle);

CheckboxLabelStyled.propTypes = propTypes;
CheckboxLabelStyled.defaultProps = defaultProps;
CheckboxLabelStyled.displayName = 'CheckboxLabelStyled';